import { createAction } from 'Helpers';
import ticketTypes from './types';

const ticketActions = {
	getListRequest: createAction(ticketTypes.LIST.REQUEST),
	getListSuccess: createAction(ticketTypes.LIST.SUCCESS),
	getListFailure: createAction(ticketTypes.LIST.FAILURE),
	getListClear: createAction(ticketTypes.LIST.CLEAR),

	getIndexRequest: createAction(ticketTypes.INDEX.REQUEST),
	getIndexSuccess: createAction(ticketTypes.INDEX.SUCCESS),
	getIndexFailure: createAction(ticketTypes.INDEX.FAILURE),

	createRequest: createAction(ticketTypes.CREATE.REQUEST),
	createSuccess: createAction(ticketTypes.CREATE.SUCCESS),
	createFailure: createAction(ticketTypes.CREATE.FAILURE),

	ticketCommentRequest: createAction(ticketTypes.COMMENT.REQUEST),
	ticketCommentSuccess: createAction(ticketTypes.COMMENT.SUCCESS),
	ticketCommentFailure: createAction(ticketTypes.COMMENT.FAILURE),
	ticketCommentClear: createAction(ticketTypes.COMMENT.CLEAR),

	ticketLogsRequest: createAction(ticketTypes.LOG.REQUEST),
	ticketLogsSuccess: createAction(ticketTypes.LOG.SUCCESS),
	ticketLogsFailure: createAction(ticketTypes.LOG.FAILURE),
	ticketLogsClear: createAction(ticketTypes.LOG.CLEAR),

	supportTicketRequest: createAction(ticketTypes.SUPPORT_PROBLEM.REQUEST),
	supportTicketSuccess: createAction(ticketTypes.SUPPORT_PROBLEM.SUCCESS),
	supportTicketFailure: createAction(ticketTypes.SUPPORT_PROBLEM.FAILURE),
	supportTicketClear: createAction(ticketTypes.SUPPORT_PROBLEM.CLEAR),
};

export default ticketActions;
